import { Component } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";

@Component({
	selector: "app-validate-signature-error-modal",
	templateUrl: "./validate-signature-error-modal.component.html",
	styleUrls: ["./validate-signature-error-modal.component.scss"],
	standalone: false
})
export class ValidateSignatureErrorModalComponent {
	modalMsg = "";

	modalLink = "";

	modalLinkText = "";

	constructor(public bsModalRef: BsModalRef) {}

	hideModal(): void {
		this.bsModalRef.hide();
	}
}
